<template>
  <el-dialog custom-class="medium-dialog" title="采购价审核" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-table
            :data="pricedata"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              prop="seedname"
              label="名称"
              align="center" fixed
              width="250" :show-overflow-tooltip="true"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="packagesize"
              label="球镜"
              width="80"
              align="left"
              header-align="center">
              <template slot-scope="scope">
                {{getY(scope.row.packagesize)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="packagesize"
              label="柱镜"
              width="80"
              align="left"
              header-align="center">
              <template slot-scope="scope">
                {{getX(scope.row.packagesize)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="数量"
              align="center"
              width="80"
              header-align="center">
              <template slot-scope="scope">
                {{scope.row.totalnumber}}
              </template>
            </el-table-column>
            <el-table-column
              prop="costprice"
              label="采购单价"
              align="left"  width="100"
              header-align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.costprice" :min="0" size="mini"
                                 onfocus="this.select()" :controls="false" style="width: 76px"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
      <span v-if="controlData.isfile&&controlData.isfile==1" style="padding-left: 15px;color: red;font-size: 14pt;"><b>赠 送</b></span>
    </div>
  </el-dialog>
</template>
<script>
  import {updatecostprice, getJxcformdetailGetList} from '@/api/set/csagreement';

  export default {
    name: "BuyUpdateCostPrice",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        controlData:{},
        pricedata:[],
        form: {
          costprice:0,
          price:0,
          isgift:0,
          discount:0,
        },
        tabledata: {},
        seedcode: '',
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          costprice: [
            {required: true, message: '请输入采购单价', trigger: 'blur'},
          ],
          price: [
            {required: true, message: '请输入核算单价', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      getY(pack){
        if(pack){
          return JSON.parse(pack).Y;
        }
        return '';
      },
      getX(pack){
        if(pack){
          return JSON.parse(pack).X;
        }
        return '';
      },
      show(item) {
        this.initForm();
        this.tabledata = item
        this.pricedata = []
        getJxcformdetailGetList({erpserial: item.erpserial}).then(response => {
          if (response.data.obj.length > 0)
            this.seedcode = response.data.obj[0].seedcode
          this.controlData=response.data.cstagreementDO;
          var priceobj = response.data.obj;
          for (let i in priceobj) {
            priceobj[i].costprice = parseFloat(priceobj[i].costtotalmoney / priceobj[i].totalnumber).toFixed(3);
            priceobj[i].oldcostprice=priceobj[i].costprice;
          }
          this.pricedata=priceobj;
        })
        this.dialogFormVisible = true;
      },
      saveData() {
        this.$confirm('确认修改价格吗？', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {

          var updateCostPrice=[];
          for (let i in this.pricedata) {
            if (!(this.controlData.isfile&&this.controlData.isfile==1)&&(!this.pricedata[i].costprice || this.pricedata[i].costprice <= 0)) {
              this.$message({
                message: '采购价必填！',
                type: 'warning'
              })
              return
            }
            if (parseFloat(this.pricedata[i].costprice) != parseFloat(this.pricedata[i].oldcostprice)) {
              updateCostPrice.push({
                unitguid: this.pricedata[i].unitguid, costprice: this.pricedata[i].costprice
                , totalnumber: this.pricedata[i].totalnumber
              })
            }
          }

          updatecostprice({
            erpserial: this.tabledata.erpserial,
            costprice: JSON.stringify(updateCostPrice),
            price: this.form.price,
            seedcode: this.seedcode,
            unitguid: this.tabledata.unitguid,
            packagesize: '',
            invoicesource: 2,
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: "审核通过",
                type: 'success'
              })
              this.dialogFormVisible = false
              //刷新列表
              this.$emit("bindGrid")
            } else {
              this.$message({
                message: "审核失败",
                type: 'error'
              })
            }
          });
        }).catch(() => {

        });
      },
      initForm() {
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyUpdateCostPrice.vue